import React from 'react';
import { runtimeHooks } from './runtime-hooks.js';
import { Icon } from './icons.jsx';
import { SLA_RULES, SUPPORT_AGENTS, SUPPORT_TENANTS, TICKETS, setTICKETS } from './support-data.jsx';
import { MacrosTab } from './support-ops-components.jsx';
import { AgentAvatar, InboxTab, SLAChip, TicketDetailPage, TicketPriorityBadge, TicketStatusBadge, TicketsTab } from './support-ticket-components.jsx';
// Suporte — Página Tickets (menu próprio)

// ── Modal: Novo Ticket ────────────────────────────────────────────────────────
const NovoTicketModal = ({ open, onClose, onToast, onAdd }) => {
  const [form, setForm] = React.useState({
    tenant: '', requester: '', email: '', canal: 'Painel do cliente',
    origem: 'Cliente', subject: '', description: '', priority: 'media',
    category: '', agent: '', tags: '', internalNote: '', attachments: [],
  });
  const [submitted, setSubmitted] = React.useState(false);
  const [showNote, setShowNote] = React.useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const agents = SUPPORT_AGENTS || [];
  const tenants = SUPPORT_TENANTS || [];
  const required = ['tenant', 'requester', 'email', 'subject', 'description'];
  const isValid = required.every(k => form[k].trim());

  const handleCreate = (assignToMe) => {
    setSubmitted(true);
    if (!isValid) return;
    const data = { ...form, agent: assignToMe ? 'Ana Vargas' : form.agent };
    if (onAdd) onAdd(data);
    else onToast && onToast('Ticket criado');
    onClose();
    setForm({ tenant:'',requester:'',email:'',canal:'Painel do cliente',origem:'Cliente',subject:'',description:'',priority:'media',category:'',agent:'',tags:'',internalNote:'',attachments:[] });
    setSubmitted(false);
    setShowNote(false);
  };

  if (!open) return null;

  const Field = ({ label, required: req, error, children }) => (
    <div style={{ marginBottom: 14 }}>
      <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 5 }}>
        {label}{req && <span style={{ color: 'var(--danger)', marginLeft: 2 }}>*</span>}
      </label>
      {children}
      {error && submitted && !form[error]?.trim() && (
        <div style={{ fontSize: 11, color: 'var(--danger)', marginTop: 3 }}>Campo obrigatório</div>
      )}
    </div>
  );

  const inputStyle = (key) => ({
    width: '100%', height: 34, padding: '0 10px',
    border: `1px solid ${submitted && !form[key]?.trim() ? 'var(--danger)' : 'var(--border-strong)'}`,
    borderRadius: 'var(--radius)', background: 'var(--bg-elevated)',
    color: 'var(--text)', fontSize: 13, fontFamily: 'inherit',
  });

  return (
    <div onClick={onClose} style={{ position:'fixed',inset:0,background:'rgba(10,22,40,0.44)',backdropFilter:'blur(3px)',zIndex:200,display:'flex',alignItems:'center',justifyContent:'center',padding:20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width:640,maxHeight:'90vh',background:'var(--bg-elevated)',borderRadius:16,boxShadow:'var(--shadow-lg)',border:'1px solid var(--border)',display:'flex',flexDirection:'column',animation:'scale-in 160ms cubic-bezier(0.2,0.8,0.2,1)' }}>
        {/* Header */}
        <div style={{ padding:'18px 22px 14px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:12 }}>
          <div style={{ width:36,height:36,borderRadius:8,background:'var(--info-bg)',display:'flex',alignItems:'center',justifyContent:'center' }}>
            <Icon name="plus" size={16} style={{ color:'var(--info)' }}/>
          </div>
          <div>
            <div style={{ fontWeight:600,fontSize:15 }}>Novo ticket</div>
            <div style={{ fontSize:12,color:'var(--text-muted)' }}>Abrir ticket manualmente para um tenant</div>
          </div>
          <button className="icon-action" style={{ marginLeft:'auto' }} onClick={onClose}><Icon name="x" size={15}/></button>
        </div>

        {/* Body */}
        <div style={{ flex:1,overflowY:'auto',padding:'20px 22px' }}>
          <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:14 }}>
            <Field label="Tenant / Loja" req error="tenant">
              <select className="select" style={{ width:'100%',height:34,border:`1px solid ${submitted&&!form.tenant?'var(--danger)':'var(--border-strong)'}` }} value={form.tenant} onChange={e=>set('tenant',e.target.value)}>
                <option value="">Selecionar tenant…</option>
                {tenants.map(t=><option key={t.id} value={t.name}>{t.name} ({t.plan})</option>)}
              </select>
              {submitted && !form.tenant && <div style={{ fontSize:11,color:'var(--danger)',marginTop:3 }}>Campo obrigatório</div>}
            </Field>
            <Field label="Solicitante" req error="requester">
              <input style={inputStyle('requester')} value={form.requester} onChange={e=>set('requester',e.target.value)} placeholder="Nome do solicitante"/>
            </Field>
          </div>

          <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:14 }}>
            <Field label="E-mail" req error="email">
              <input style={inputStyle('email')} type="email" value={form.email} onChange={e=>set('email',e.target.value)} placeholder="email@loja.com.br"/>
            </Field>
            <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:8 }}>
              <Field label="Canal">
                <select className="select" style={{ width:'100%',height:34 }} value={form.canal} onChange={e=>set('canal',e.target.value)}>
                  {['Painel do cliente','E-mail','WhatsApp','Telefone','Interno'].map(c=><option key={c}>{c}</option>)}
                </select>
              </Field>
              <Field label="Origem">
                <select className="select" style={{ width:'100%',height:34 }} value={form.origem} onChange={e=>set('origem',e.target.value)}>
                  {['Cliente','Sucesso do Cliente','Financeiro','Técnico','Comercial'].map(c=><option key={c}>{c}</option>)}
                </select>
              </Field>
            </div>
          </div>

          <Field label="Assunto" req error="subject">
            <input style={{ ...inputStyle('subject'), height:36 }} value={form.subject} onChange={e=>set('subject',e.target.value)} placeholder="Descreva brevemente o problema"/>
          </Field>

          <Field label="Descrição" req error="description">
            <textarea
              value={form.description} onChange={e=>set('description',e.target.value)}
              placeholder="Descreva o problema em detalhes…"
              style={{ width:'100%',minHeight:88,padding:'8px 10px',border:`1px solid ${submitted&&!form.description?'var(--danger)':'var(--border-strong)'}`,borderRadius:'var(--radius)',background:'var(--bg-elevated)',color:'var(--text)',fontSize:13,fontFamily:'inherit',resize:'vertical',lineHeight:1.5 }}
            />
            {submitted && !form.description && <div style={{ fontSize:11,color:'var(--danger)',marginTop:3 }}>Campo obrigatório</div>}
          </Field>

          <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:14,marginBottom:14 }}>
            <Field label="Prioridade">
              <select className="select" style={{ width:'100%',height:34 }} value={form.priority} onChange={e=>set('priority',e.target.value)}>
                <option value="baixa">Baixa</option>
                <option value="media">Média</option>
                <option value="alta">Alta</option>
                <option value="urgente">Urgente</option>
              </select>
            </Field>
            <Field label="Categoria">
              <select className="select" style={{ width:'100%',height:34 }} value={form.category} onChange={e=>set('category',e.target.value)}>
                <option value="">Selecionar…</option>
                {['Domínio','Pagamento','Integrações','E-mails transacionais','Google Merchant','Billing','Catálogo','Frete','Outro'].map(c=><option key={c}>{c}</option>)}
              </select>
            </Field>
            <Field label="Responsável">
              <select className="select" style={{ width:'100%',height:34 }} value={form.agent} onChange={e=>set('agent',e.target.value)}>
                <option value="">Não atribuído</option>
                {agents.map(a=><option key={a.id} value={a.name}>{a.name}</option>)}
              </select>
            </Field>
          </div>

          <Field label="Tags">
            <input style={{ ...inputStyle('tags') }} value={form.tags} onChange={e=>set('tags',e.target.value)} placeholder="domínio, dns, configuração…"/>
          </Field>

          {/* Nota interna opcional */}
          {!showNote ? (
            <button className="btn sm ghost" style={{ width:'100%',justifyContent:'center',borderStyle:'dashed',borderColor:'var(--border-strong)' }} onClick={()=>setShowNote(true)}>
              <Icon name="lock" size={13}/>Adicionar nota interna
            </button>
          ) : (
            <Field label="Nota interna">
              <textarea
                value={form.internalNote} onChange={e=>set('internalNote',e.target.value)}
                placeholder="Nota visível apenas para a equipe…"
                style={{ width:'100%',minHeight:68,padding:'8px 10px',border:'1px solid #fde68a',borderRadius:'var(--radius)',background:'#fffbeb',color:'#78350f',fontSize:13,fontFamily:'inherit',resize:'vertical' }}
              />
            </Field>
          )}
        </div>

        {/* Footer */}
        <div style={{ padding:'12px 22px',borderTop:'1px solid var(--border)',background:'var(--bg-subtle)',display:'flex',gap:8,justifyContent:'flex-end',alignItems:'center' }}>
          <span style={{ fontSize:12,color:'var(--text-muted)',marginRight:'auto' }}>* Campos obrigatórios</span>
          <button className="btn ghost" onClick={onClose}>Cancelar</button>
          <button className="btn" onClick={()=>handleCreate(true)}>
            <Icon name="users" size={13}/>Criar e atribuir para mim
          </button>
          <button className="btn primary" onClick={()=>handleCreate(false)}>
            <Icon name="plus" size={13}/>Criar ticket
          </button>
        </div>
      </div>
    </div>
  );
};

// ── Modal: Nova Macro ──────────────────────────────────────────────────────────
const NovaMacroModal = ({ open, onClose, onToast, onAdd }) => {
  const [form, setForm] = React.useState({ name:'', category:'Geral', body:'', status:'ativo' });
  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const VARS = ['{{cliente_nome}}', '{{tenant_nome}}', '{{ticket_id}}', '{{link_artigo}}'];

  if (!open) return null;
  return (
    <div onClick={onClose} style={{ position:'fixed',inset:0,background:'rgba(10,22,40,0.44)',backdropFilter:'blur(3px)',zIndex:200,display:'flex',alignItems:'center',justifyContent:'center',padding:20 }}>
      <div onClick={e=>e.stopPropagation()} style={{ width:580,background:'var(--bg-elevated)',borderRadius:16,boxShadow:'var(--shadow-lg)',border:'1px solid var(--border)',overflow:'hidden',animation:'scale-in 160ms cubic-bezier(0.2,0.8,0.2,1)' }}>
        <div style={{ padding:'18px 22px 14px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:12 }}>
          <div style={{ width:36,height:36,borderRadius:8,background:'var(--info-bg)',display:'flex',alignItems:'center',justifyContent:'center' }}><Icon name="zap" size={16} style={{ color:'var(--info)' }}/></div>
          <div><div style={{ fontWeight:600,fontSize:15 }}>Nova macro</div><div style={{ fontSize:12,color:'var(--text-muted)' }}>Resposta pronta para o atendimento</div></div>
          <button className="icon-action" style={{ marginLeft:'auto' }} onClick={onClose}><Icon name="x" size={15}/></button>
        </div>
        <div style={{ padding:'20px 22px' }}>
          <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:14 }}>
            <div>
              <label style={{ display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:5 }}>Nome da macro *</label>
              <input value={form.name} onChange={e=>set('name',e.target.value)} style={{ width:'100%',height:34,padding:'0 10px',border:'1px solid var(--border-strong)',borderRadius:'var(--radius)',background:'var(--bg-elevated)',color:'var(--text)',fontSize:13,fontFamily:'inherit' }} placeholder="Ex.: Solicitar mais informações"/>
            </div>
            <div>
              <label style={{ display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:5 }}>Categoria</label>
              <select className="select" style={{ width:'100%',height:34 }} value={form.category} onChange={e=>set('category',e.target.value)}>
                {['Geral','Domínio','Billing','E-mail','Escalação','Encerramento'].map(c=><option key={c}>{c}</option>)}
              </select>
            </div>
          </div>
          <div style={{ marginBottom:14 }}>
            <label style={{ display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:5 }}>Texto da resposta *</label>
            <textarea value={form.body} onChange={e=>set('body',e.target.value)} placeholder="Escreva o texto da macro…" style={{ width:'100%',minHeight:120,padding:'10px',border:'1px solid var(--border-strong)',borderRadius:'var(--radius)',background:'var(--bg-elevated)',color:'var(--text)',fontSize:13,fontFamily:'inherit',resize:'vertical',lineHeight:1.6 }}/>
          </div>
          <div style={{ marginBottom:14 }}>
            <label style={{ display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:7 }}>Variáveis disponíveis</label>
            <div style={{ display:'flex',gap:6,flexWrap:'wrap' }}>
              {VARS.map(v=>(
                <button key={v} className="btn sm" style={{ fontFamily:'var(--font-mono,monospace)',fontSize:11 }} onClick={()=>set('body',form.body+v)}>
                  {v}
                </button>
              ))}
            </div>
          </div>
          <div>
            <label style={{ display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:5 }}>Status</label>
            <div style={{ display:'flex',gap:8 }}>
              {['ativo','inativo'].map(s=>(
                <button key={s} onClick={()=>set('status',s)} style={{ padding:'6px 14px',borderRadius:'var(--radius)',border:`1.5px solid ${form.status===s?'var(--brand-navy)':'var(--border-strong)'}`,background:form.status===s?'color-mix(in srgb,var(--brand-navy) 6%,var(--bg-elevated))':'var(--bg-elevated)',color:'var(--text)',fontSize:13,fontWeight:form.status===s?600:500,cursor:'pointer' }}>
                  {s.charAt(0).toUpperCase()+s.slice(1)}
                </button>
              ))}
            </div>
          </div>
        </div>
        <div style={{ padding:'12px 22px',borderTop:'1px solid var(--border)',background:'var(--bg-subtle)',display:'flex',gap:8,justifyContent:'flex-end' }}>
          <button className="btn ghost" onClick={onClose}>Cancelar</button>
          <button className="btn primary" onClick={()=>{
            if (!form.name || !form.body) { onToast&&onToast('Preencha nome e texto da macro'); return; }
            if (onAdd) onAdd({ ...form, id: 'mac_' + Date.now(), status: form.status, usage_count: 0, created_at: 'Agora', updated_at: 'Agora' });
            onToast&&onToast(`Macro "${form.name}" criada`);
            onClose();
          }}>
            <Icon name="check" size={13}/>Criar macro
          </button>
        </div>
      </div>
    </div>
  );
};

// ── Modal: Nova Regra de SLA ───────────────────────────────────────────────────
const NovaRegrasSLAModal = ({ open, onClose, onToast, onAdd }) => {
  const [form, setForm] = React.useState({ name:'',plan:'Pro',priority:'media',firstResponse:'4h',resolution:'24h',escalation:'8h',status:'ativo' });
  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  if (!open) return null;
  return (
    <div onClick={onClose} style={{ position:'fixed',inset:0,background:'rgba(10,22,40,0.44)',backdropFilter:'blur(3px)',zIndex:200,display:'flex',alignItems:'center',justifyContent:'center',padding:20 }}>
      <div onClick={e=>e.stopPropagation()} style={{ width:540,background:'var(--bg-elevated)',borderRadius:16,boxShadow:'var(--shadow-lg)',border:'1px solid var(--border)',overflow:'hidden' }}>
        <div style={{ padding:'18px 22px 14px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:12 }}>
          <div style={{ width:36,height:36,borderRadius:8,background:'var(--warning-bg)',display:'flex',alignItems:'center',justifyContent:'center' }}><Icon name="clock" size={16} style={{ color:'var(--warning)' }}/></div>
          <div><div style={{ fontWeight:600,fontSize:15 }}>Nova regra de SLA</div><div style={{ fontSize:12,color:'var(--text-muted)' }}>Tempo de resposta e resolução por plano/prioridade</div></div>
          <button className="icon-action" style={{ marginLeft:'auto' }} onClick={onClose}><Icon name="x" size={15}/></button>
        </div>
        <div style={{ padding:'20px 22px' }}>
          <div style={{ marginBottom:14 }}>
            <label style={{ display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:5 }}>Nome da regra *</label>
            <input value={form.name} onChange={e=>set('name',e.target.value)} style={{ width:'100%',height:34,padding:'0 10px',border:'1px solid var(--border-strong)',borderRadius:'var(--radius)',background:'var(--bg-elevated)',color:'var(--text)',fontSize:13,fontFamily:'inherit' }} placeholder="Ex.: Pro — Alta Prioridade"/>
          </div>
          <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:14 }}>
            <div>
              <label style={{ display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:5 }}>Plano</label>
              <select className="select" style={{ width:'100%',height:34 }} value={form.plan} onChange={e=>set('plan',e.target.value)}>
                {['Basic','Pro','Enterprise','Todos'].map(p=><option key={p}>{p}</option>)}
              </select>
            </div>
            <div>
              <label style={{ display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:5 }}>Prioridade</label>
              <select className="select" style={{ width:'100%',height:34 }} value={form.priority} onChange={e=>set('priority',e.target.value)}>
                <option value="baixa">Baixa</option>
                <option value="media">Média</option>
                <option value="alta">Alta</option>
                <option value="urgente">Urgente</option>
              </select>
            </div>
          </div>
          <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:14,marginBottom:14 }}>
            {[{ label:'1ª Resposta',key:'firstResponse',ph:'4h' },{ label:'Resolução',key:'resolution',ph:'24h' },{ label:'Escalonamento',key:'escalation',ph:'8h' }].map(f=>(
              <div key={f.key}>
                <label style={{ display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:5 }}>{f.label}</label>
                <input value={form[f.key]} onChange={e=>set(f.key,e.target.value)} style={{ width:'100%',height:34,padding:'0 10px',border:'1px solid var(--border-strong)',borderRadius:'var(--radius)',background:'var(--bg-elevated)',color:'var(--text)',fontSize:13,fontFamily:'inherit' }} placeholder={f.ph}/>
              </div>
            ))}
          </div>
          <div>
            <label style={{ display:'block',fontSize:12,fontWeight:600,color:'var(--text-secondary)',marginBottom:5 }}>Horário de atendimento</label>
            <select className="select" style={{ width:'100%',height:34 }}>
              <option>Seg-Sex, 09:00–18:00 (Brasília)</option>
              <option>24 horas / 7 dias</option>
              <option>Seg-Sáb, 08:00–20:00 (Brasília)</option>
            </select>
          </div>
        </div>
        <div style={{ padding:'12px 22px',borderTop:'1px solid var(--border)',background:'var(--bg-subtle)',display:'flex',gap:8,justifyContent:'flex-end' }}>
          <button className="btn ghost" onClick={onClose}>Cancelar</button>
          <button className="btn primary" onClick={()=>{
            if (!form.name) { onToast&&onToast('Informe o nome da regra'); return; }
            if (onAdd) onAdd({ ...form, id: 'sla_' + Date.now(), is_active: true, created_at: 'Agora', updated_at: 'Agora' });
            onToast&&onToast(`Regra "${form.name}" criada`);
            onClose();
          }}>
            <Icon name="check" size={13}/>Criar regra
          </button>
        </div>
      </div>
    </div>
  );
};

// ── Tab: Regras de SLA ──────────────────────────────────────────────────────
const SLARulesTab = ({ onToast }) => {
  const [rules, setRules] = React.useState(() => SLA_RULES || []);
  const [showModal, setShowModal] = React.useState(false);

  const handleAddRule = (newRule) => {
    setRules(rs => [newRule, ...rs]);
  };

  const slaKpis = [
    { label:'SLA vencido hoje',     value:2,       icon:'alert',   danger:true },
    { label:'SLA vencendo em 1h',   value:3,       icon:'clock',   warn:true   },
    { label:'Tempo médio resposta',  value:'1h 48min',icon:'activity', small:true },
    { label:'Cumprimento de SLA',   value:'91%',   icon:'check',   ok:true, small:true },
  ];

  return (
    <div style={{ display:'flex',flexDirection:'column',gap:20 }}>
      <NovaRegrasSLAModal open={showModal} onClose={()=>setShowModal(false)} onToast={onToast} onAdd={handleAddRule}/>

      {/* KPIs */}
      <div style={{ display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12 }}>
        {slaKpis.map(k=>(
          <div key={k.label} className="kpi">
            <div className="label"><Icon name={k.icon} size={14}/>{k.label}</div>
            <div className="value" style={{ fontSize:k.small?20:26,color:k.danger?'var(--danger)':k.warn?'var(--warning)':k.ok?'var(--success)':undefined }}>{k.value}</div>
          </div>
        ))}
      </div>

      {/* Tabela de regras */}
      <div className="table-wrap">
        <div className="table-toolbar">
          <div style={{ fontWeight:600,fontSize:14 }}>Regras de SLA</div>
          <p style={{ fontSize:12,color:'var(--text-muted)',margin:0 }}>Tempo de resposta e resolução por plano/prioridade.</p>
          <div style={{ marginLeft:'auto' }}>
            <button className="btn primary sm" onClick={()=>setShowModal(true)}>
              <Icon name="plus" size={13}/>Nova regra
            </button>
          </div>
        </div>
        <table className="data">
          <thead>
            <tr>
              <th>Nome da regra</th>
              <th>Prioridade</th>
              <th>Plano</th>
              <th>1ª Resposta</th>
              <th>Resolução</th>
              <th>Escalonamento</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {rules.map(r=>(
              <tr key={r.id}>
                <td><span style={{ fontWeight:500,fontSize:13 }}>{r.name}</span></td>
                <td><span className={`badge ${r.priority==='urgente'?'danger':r.priority==='alta'?'warning':r.priority==='media'?'info':'neutral'}`} style={{ fontSize:10 }}><span className="dot"/>{r.priority.charAt(0).toUpperCase()+r.priority.slice(1)}</span></td>
                <td><span className="badge neutral" style={{ fontSize:10 }}>{r.plan}</span></td>
                <td><span style={{ fontSize:12,fontWeight:600,color:'var(--text)' }}>{r.firstResponse}</span></td>
                <td><span style={{ fontSize:12,color:'var(--text-secondary)' }}>{r.resolution}</span></td>
                <td><span style={{ fontSize:12,color:'var(--text-muted)' }}>{r.escalation}</span></td>
                <td><span className="badge success" style={{ fontSize:10 }}><span className="dot"/>Ativo</span></td>
                <td>
                  <div className="row-actions">
                    <button className="icon-action" title="Editar" onClick={()=>onToast&&onToast('Editando regra…')}><Icon name="edit" size={13}/></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Tickets em risco */}
      <div className="card" style={{ overflow:'hidden' }}>
        <div className="card-head">
          <Icon name="alert" size={15} style={{ color:'var(--warning)' }}/>
          <h3>Tickets em risco de SLA</h3>
          <span className="sub">Requerem ação imediata</span>
        </div>
        <div>
          {(TICKETS||[]).filter(t=>t.sla==='vencendo'||t.sla==='vencido').map(t=>(
            <div key={t.id} style={{ display:'flex',alignItems:'center',gap:14,padding:'12px 20px',borderBottom:'1px solid var(--border)' }}>
              <div style={{ width:32,height:32,borderRadius:8,background:t.sla==='vencido'?'var(--danger-bg)':'var(--warning-bg)',display:'flex',alignItems:'center',justifyContent:'center' }}>
                <Icon name="clock" size={14} style={{ color:t.sla==='vencido'?'var(--danger)':'var(--warning)' }}/>
              </div>
              <div style={{ flex:1,minWidth:0 }}>
                <div style={{ fontWeight:500,fontSize:13 }}>{t.subject}</div>
                <div style={{ fontSize:11,color:'var(--text-muted)' }}>{t.tenant} · {t.plan} · {t.category}</div>
              </div>
              <span className={`badge ${t.sla==='vencido'?'danger':'warning'}`} style={{ fontSize:10 }}><span className="dot"/>{t.slaTime}</span>
              <span className={`badge ${t.priority==='urgente'?'danger':t.priority==='alta'?'warning':'info'}`} style={{ fontSize:10 }}><span className="dot"/>{t.priority}</span>
              <button className="btn sm primary" onClick={()=>onToast&&onToast(`Abrindo ticket ${t.id}`)}>Abrir</button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

// ── Página principal: Tickets ───────────────────────────────────────────────
const SupportTicketsPage = ({ onToast, onNav, stores, initialTicketId }) => {
  const [tab, setTab]         = React.useState('inbox');
  const [subPage, setSubPage] = React.useState(null);
  const [showNewTicket, setShowNewTicket] = React.useState(false);
  const [showNewMacro, setShowNewMacro]   = React.useState(false);
  const [tickets, setTickets] = React.useState(() => TICKETS || []);

  // Deep-link: abrir ticket diretamente pelo ID (ex: vindo de notificação)
  React.useEffect(() => {
    if (initialTicketId) {
      const t = tickets.find(tk => tk.id === initialTicketId || tk.id === '#' + initialTicketId.replace('#', ''));
      if (t) setSubPage({ type: 'ticket-detail', ticket: t });
    }
  }, [initialTicketId]);

  const handleUpdateTicket = React.useCallback((id, updates) => {
    setTickets(ts => ts.map(t => t.id === id ? { ...t, ...updates } : t));
    if (TICKETS) setTICKETS((TICKETS || []).map(t => t.id === id ? { ...t, ...updates } : t));
  }, []);

  const handleAddTicket = (ticketData) => {
    const newId = '#' + (4900 + Math.floor(Math.random() * 100));
    const newTicket = {
      id: newId,
      subject: ticketData.subject,
      tenant: ticketData.tenant,
      plan: 'Pro',
      requester: ticketData.requester,
      email: ticketData.email,
      channel: ticketData.canal,
      status: 'novo',
      priority: ticketData.priority,
      category: ticketData.category || 'Geral',
      agent: ticketData.agent || '',
      sla: 'normal',
      slaTime: '4h restantes',
      lastUpdate: 'Agora',
      tags: ticketData.tags ? ticketData.tags.split(',').map(t => t.trim()).filter(Boolean) : [],
      preview: ticketData.description?.slice(0, 100),
    };
    setTickets(ts => [newTicket, ...ts]);
    setTICKETS([newTicket, ...(TICKETS || [])]);
    onToast && onToast(`Ticket ${newId} criado com sucesso`);
  };

  const TABS = [
    { id:'inbox',       label:'Inbox',           icon:'inbox'         },
    { id:'todos',       label:'Todos os tickets', icon:'list'          },
    { id:'meus',        label:'Meus tickets',     icon:'users'         },
    { id:'unassigned',  label:'Não atribuídos',   icon:'slash'         },
    { id:'sla-risk',    label:'SLA vencendo',     icon:'clock'         },
    { id:'macros',      label:'Macros',           icon:'zap'           },
    { id:'sla-rules',   label:'Regras de SLA',    icon:'shield'        },
  ];

  const mainKpis = [
    { label:'Tickets abertos',      value: tickets.filter(t=>t.status==='aberto'||t.status==='novo').length,             icon:'messageCircle'              },
    { label:'Aguardando cliente',   value: tickets.filter(t=>t.status==='aguardando_cliente').length,                    icon:'clock',    warn:true         },
    { label:'Aguardando suporte',   value: tickets.filter(t=>t.status==='aguardando_suporte').length,                    icon:'clock',    warn:true         },
    { label:'Não atribuídos',       value: tickets.filter(t=>!t.agent).length,                                           icon:'slash'                      },
    { label:'SLA vencido',          value: tickets.filter(t=>t.sla==='vencido').length,                                  icon:'alert',    danger:true       },
    { label:'1ª resposta média',    value: '1h 48min',                                                                   icon:'activity', small:true        },
  ];

  if (subPage?.type === 'ticket-detail') {
    const currentTicket = tickets.find(t => t.id === subPage.ticket.id) || subPage.ticket;
    return (
      <div className="content wide" style={{ maxWidth:1280 }}>
        {/* Deep-link breadcrumb */}
        <div style={{ fontSize:11,color:'var(--text-muted)',marginBottom:8,display:'flex',alignItems:'center',gap:5 }}>
          <span style={{ fontFamily:'JetBrains Mono,monospace',opacity:.6 }}>/admin/support/tickets/{currentTicket.id}</span>
        </div>
        <TicketDetailPage ticket={currentTicket} onBack={()=>setSubPage(null)} onToast={onToast} onNav={onNav}
          onUpdate={handleUpdateTicket}
        />
      </div>
    );
  }

  const openDetail = (ticket) => setSubPage({ type:'ticket-detail', ticket });

  return (
    <div className="content wide" style={{ maxWidth:1400 }}>
      <NovoTicketModal open={showNewTicket} onClose={()=>setShowNewTicket(false)} onToast={onToast} onAdd={handleAddTicket}/>
      <NovaMacroModal  open={showNewMacro}  onClose={()=>setShowNewMacro(false)}  onToast={onToast} onAdd={(m) => { if (runtimeHooks.macroTabAdd) runtimeHooks.macroTabAdd(m); }}/>

      {/* Header */}
      <div className="page-header">
        <div>
          <h1>Tickets</h1>
          <p className="sub">Inbox, filas, SLA e atendimento ao cliente.</p>
          <div style={{ fontSize:11,fontFamily:'JetBrains Mono,monospace',color:'var(--text-muted)',opacity:.6,marginTop:3 }}>
            {tab === 'macros' ? '/admin/support/tickets/macros' : tab === 'sla-rules' ? '/admin/support/tickets/sla' : '/admin/support/tickets'}
          </div>
        </div>
        <div className="actions">
          <button className="btn" onClick={()=>setTab('sla-rules')}><Icon name="clock" size={14}/>Configurar SLA</button>
          <button className="btn" onClick={()=>setShowNewMacro(true)}><Icon name="zap" size={14}/>Gerenciar macros</button>
          <button className="btn primary" onClick={()=>setShowNewTicket(true)}><Icon name="plus" size={14}/>Novo ticket</button>
        </div>
      </div>

      {/* KPIs */}
      <div style={{ display:'grid',gridTemplateColumns:'repeat(6,1fr)',gap:12,marginBottom:20 }}>
        {mainKpis.map(k=>(
          <div key={k.label} className="kpi">
            <div className="label"><Icon name={k.icon} size={14}/>{k.label}</div>
            <div className="value" style={{ fontSize:k.small?20:26,color:k.danger?'var(--danger)':k.warn?'var(--warning)':undefined }}>{k.value}</div>
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div style={{ display:'flex',borderBottom:'1px solid var(--border)',marginBottom:24,overflowX:'auto' }}>
        {TABS.map(t=>(
          <button key={t.id} onClick={()=>setTab(t.id)} style={{
            display:'flex',alignItems:'center',gap:6,padding:'9px 14px',border:'none',background:'transparent',
            fontSize:13,fontWeight:tab===t.id?600:500,color:tab===t.id?'var(--text)':'var(--text-muted)',
            borderBottom:tab===t.id?'2px solid var(--brand-navy)':'2px solid transparent',
            marginBottom:-1,cursor:'pointer',whiteSpace:'nowrap',transition:'color 120ms',
          }}>
            <Icon name={t.icon} size={13}/>{t.label}
          </button>
        ))}
      </div>

      {/* Tab content */}
      {tab === 'inbox' && <InboxTab onOpenDetail={openDetail} onToast={onToast} onNav={onNav} tickets={tickets} onTicketUpdate={handleUpdateTicket}/>}
      {tab === 'todos' && <TicketsTab onOpenDetail={openDetail} onToast={onToast} tickets={tickets} onTicketUpdate={handleUpdateTicket}/>}
      {tab === 'meus'  && <TicketsTabFiltered filter="mine"       onOpenDetail={openDetail} onToast={onToast} tickets={tickets} onTicketUpdate={handleUpdateTicket}/>}
      {tab === 'unassigned' && <TicketsTabFiltered filter="unassigned" onOpenDetail={openDetail} onToast={onToast} tickets={tickets} onTicketUpdate={handleUpdateTicket}/>}
      {tab === 'sla-risk'   && <TicketsTabFiltered filter="sla"        onOpenDetail={openDetail} onToast={onToast} tickets={tickets} onTicketUpdate={handleUpdateTicket}/>}
      {tab === 'macros'   && <MacrosTab onToast={onToast} onNewMacro={()=>setShowNewMacro(true)}/>}
      {tab === 'sla-rules'&& <SLARulesTab onToast={onToast}/>}
    </div>
  );
};

// ── TicketsTabFiltered: versão filtrada de TicketsTab ─────────────────────────
const TicketsTabFiltered = ({ filter, onOpenDetail, onToast, tickets: ticketsProp, onTicketUpdate }) => {
  const [selected, setSelected] = React.useState(null);
  const tickets = ticketsProp || TICKETS || [];

  const updateTicket = (id, updates) => {
    if (onTicketUpdate) {
      onTicketUpdate(id, updates);
    } else {
      if (TICKETS) setTICKETS(TICKETS.map(t => t.id === id ? { ...t, ...updates } : t));
    }
    if (updates.status === 'resolvido' || updates.status === 'fechado') setSelected(null);
  };
  const filtered = tickets.filter(t => {
    if (filter === 'mine')       return t.agent === 'Ana Vargas';
    if (filter === 'unassigned') return !t.agent;
    if (filter === 'sla')        return t.sla === 'vencendo' || t.sla === 'vencido';
    return true;
  });
  const preview = selected ? tickets.find(t => t.id === selected) : null;

  return (
    <div style={{ display:'flex',gap:16,alignItems:'flex-start' }}>
      <div style={{ flex:1,minWidth:0 }}>
        <div className="table-wrap">
          <table className="data">
            <thead>
              <tr>
                <th>ID</th><th>Assunto</th><th>Tenant / Loja</th><th>Solicitante</th>
                <th>Status</th><th>Prioridade</th><th>Responsável</th><th>SLA</th><th>Atualização</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(t=>(
                <tr key={t.id} onClick={()=>setSelected(s=>s===t.id?null:t.id)} style={{ cursor:'pointer',background:selected===t.id?'color-mix(in srgb,var(--primary) 6%,var(--bg-elevated))':undefined }}>
                  <td><span className="mono" style={{ fontSize:12,color:'var(--text-muted)',fontWeight:500 }}>{t.id}</span></td>
                  <td><div style={{ fontWeight:500,fontSize:13,maxWidth:220,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap' }}>{t.subject}</div><div style={{ fontSize:11,color:'var(--text-muted)' }}>{t.category}</div></td>
                  <td><div style={{ fontSize:13,fontWeight:500 }}>{t.tenant}</div><span className="badge neutral" style={{ fontSize:10 }}>{t.plan}</span></td>
                  <td><div style={{ fontSize:13 }}>{t.requester}</div><div style={{ fontSize:11,color:'var(--text-muted)' }}>{t.channel}</div></td>
                  <td><TicketStatusBadge status={t.status}/></td>
                  <td><TicketPriorityBadge priority={t.priority}/></td>
                  <td><AgentAvatar agent={t.agent}/></td>
                  <td><SLAChip sla={t.sla} time={t.slaTime}/></td>
                  <td style={{ fontSize:12,color:'var(--text-muted)',whiteSpace:'nowrap' }}>{t.lastUpdate}</td>
                </tr>
              ))}
              {filtered.length===0&&(
                <tr><td colSpan={9} style={{ textAlign:'center',padding:'48px 20px',color:'var(--text-muted)' }}>
                  <div style={{ marginBottom:8 }}><Icon name="inbox" size={28} style={{ opacity:.2 }}/></div>
                  Nenhum ticket nesta fila
                </td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {preview&&(
        <div className="card" style={{ width:320,flexShrink:0,overflow:'hidden' }}>
          <div style={{ padding:'12px 14px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:6 }}>
            <span className="mono" style={{ fontSize:12,color:'var(--text-muted)',fontWeight:600 }}>{preview.id}</span>
            <TicketStatusBadge status={preview.status} sm/>
            <button className="icon-action" style={{ marginLeft:'auto' }} onClick={()=>setSelected(null)}><Icon name="x" size={14}/></button>
          </div>
          <div style={{ padding:'12px 14px',borderBottom:'1px solid var(--border)' }}>
            <div style={{ fontWeight:600,fontSize:13,marginBottom:8 }}>{preview.subject}</div>
            {[{l:'Tenant',v:preview.tenant},{l:'Plano',v:preview.plan},{l:'Solicitante',v:preview.requester},{l:'Responsável',v:preview.agent||'—'}].map(r=>(
              <div key={r.l} style={{ display:'flex',justifyContent:'space-between',fontSize:12,padding:'3px 0' }}>
                <span style={{ color:'var(--text-muted)' }}>{r.l}</span>
                <span style={{ fontWeight:500 }}>{r.v}</span>
              </div>
            ))}
          </div>
          <div style={{ padding:'10px 14px',display:'flex',gap:6 }}>
            <button className="btn sm primary" style={{ flex:1,justifyContent:'center' }} onClick={()=>onOpenDetail&&onOpenDetail(preview)}>
              <Icon name="messageCircle" size={12}/>Abrir
            </button>
            <button className="btn sm" onClick={()=>{ if(selected) updateTicket(selected, { agent: 'Ana Vargas', lastUpdate: 'Agora' }); onToast&&onToast('Ticket atribuído para você'); }}><Icon name="users" size={12}/></button>
            <button className="btn sm danger-outline" onClick={()=>{ if(selected) updateTicket(selected, { status: 'resolvido', lastUpdate: 'Agora' }); onToast&&onToast('Ticket encerrado'); }}><Icon name="check" size={12}/></button>
          </div>
        </div>
      )}
    </div>
  );
};

export {
  NovaMacroModal,
  NovoTicketModal,
  SLARulesTab,
  SupportTicketsPage,
  TicketsTabFiltered,
};
